export type EquipTabKey =
  | 'general'
  | 'mainParts'
  | 'stockParts'
  | 'calibrations'
  | 'repairs'
  | 'managementStandard'
  | 'inspectionSheet';

export const EQUIP_TABS: { key: EquipTabKey; label: string }[] = [
  { key: 'general', label: '기본정보' },
  { key: 'mainParts', label: '주요 부속품' },
  { key: 'stockParts', label: '보유 부속품' },
  { key: 'calibrations', label: '교정 이력' },
  { key: 'repairs', label: '교체수리 이력' },
  { key: 'managementStandard', label: '관리 기준서' },
  { key: 'inspectionSheet', label: '점검시트' },
];
